import { useRouteQuery } from "@vueuse/router";

export const useRouteCompany = () =>
  useRouteQuery<string, number>("company_id", "", {
    mode: "push",
    transform: {
      // TODO: This results in a NaN if the value is not a number
      // Is that expected behavior?
      get: (value) => Number.parseInt(value),
      set: (value) => (value ? String(value) : ""),
    },
  });
